import { useEffect, useRef, useState } from "react";
import { CalendarDays } from "lucide-react";

const toAu = (iso) => (iso && /^\d{4}-\d{2}-\d{2}$/.test(iso) ? `${iso.slice(8, 10)}/${iso.slice(5, 7)}/${iso.slice(0, 4)}` : "");
const toIso = (au) => { const m = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(au); return m ? `${m[3]}-${m[2]}-${m[1]}` : ""; };

export function AuDateInput({ value, onChange, className = "", style, testid }) {
  const [txt, setTxt] = useState(toAu(value));
  const pick = useRef(null);
  useEffect(() => { setTxt(toAu(value)); }, [value]);
  const type = (raw) => {
    const d = raw.replace(/\D/g, "").slice(0, 8);
    const t = [d.slice(0, 2), d.slice(2, 4), d.slice(4)].filter(Boolean).join("/");
    setTxt(t);
    const iso = toIso(t);
    if (iso || !t) onChange(iso);
  };
  return (
    <div className="relative">
      <input type="text" inputMode="numeric" placeholder="DD/MM/YYYY" className={`${className} pr-9`} style={style} value={txt} onChange={(e) => type(e.target.value)} data-testid={testid} />
      <CalendarDays className="pointer-events-none absolute right-2 top-1/2 h-4 w-4 -translate-y-1/2 opacity-70" />
      <input ref={pick} type="date" aria-label="Open calendar" className="bos-date-overlay absolute inset-y-0 right-0 w-9 cursor-pointer opacity-0" value={value || ""}
        onClick={(e) => { try { e.currentTarget.showPicker?.(); } catch { /* cross-origin iframe: native indicator handles it */ } }}
        onChange={(e) => onChange(e.target.value)} data-testid={testid ? `${testid}-calendar` : undefined} />
    </div>
  );
}
